module.exports = __webpack_public_path__ + "img/gxrz.02f8961a.png";